import { apiService } from './api';
import { ApiResponse, QuestionBranch } from '../types';

class QuestionBranchService {
  async createBranch(data: {
    parentQuestionId: string;
    parentOptionValue: string;
    childQuestionId: string;
    conditionType?: string;
  }): Promise<QuestionBranch> {
    const response = await apiService.post<ApiResponse<{ branch: QuestionBranch }>>(
      '/question-branches',
      data
    );
    if (response.data?.branch) {
      return response.data.branch;
    }
    throw new Error(response.message || 'Failed to create branch');
  }

  async getBranchesForParent(parentQuestionId: string): Promise<QuestionBranch[]> {
    const response = await apiService.get<ApiResponse<{ branches: QuestionBranch[] }>>(
      `/question-branches/parent/${parentQuestionId}`
    );
    if (response.data?.branches) {
      return response.data.branches;
    }
    throw new Error(response.message || 'Failed to fetch branches');
  }

  async getBranchesForChild(childQuestionId: string): Promise<QuestionBranch[]> {
    const response = await apiService.get<ApiResponse<{ branches: QuestionBranch[] }>>(
      `/question-branches/child/${childQuestionId}`
    );
    if (response.data?.branches) {
      return response.data.branches;
    }
    throw new Error(response.message || 'Failed to fetch branches');
  }

  async deleteBranch(branchId: number): Promise<void> {
    const response = await apiService.delete<ApiResponse<void>>(
      `/question-branches/${branchId}`
    );
    if (!response.success) {
      throw new Error(response.message || 'Failed to delete branch');
    }
  }
}

export const questionBranchService = new QuestionBranchService();

